import { createAction } from "redux-actions";
import { SELECT_PAIR } from "../constants/actionTypes";

export const selectPair = createAction(SELECT_PAIR);
